var map = {
	"./account/en.json": [
		4440,
		4440
	],
	"./account/fr.json": [
		1258,
		1258
	],
	"./address/en.json": [
		6378,
		6378
	],
	"./address/fr.json": [
		8711,
		8711
	],
	"./auth/en.json": [
		5405,
		5405
	],
	"./auth/fr.json": [
		8857,
		8857
	],
	"./bucket/en.json": [
		8528,
		8528
	],
	"./bucket/fr.json": [
		7680,
		7680
	],
	"./buyer/en.json": [
		840,
		840
	],
	"./buyer/fr.json": [
		99,
		99
	],
	"./confirm/en.json": [
		9404,
		9404
	],
	"./confirm/fr.json": [
		463,
		463
	],
	"./customer/en.json": [
		1613,
		1613
	],
	"./customer/fr.json": [
		6219,
		6219
	],
	"./delivery/en.json": [
		4381,
		4381
	],
	"./delivery/fr.json": [
		5681,
		5681
	],
	"./discount/en.json": [
		7314,
		7314
	],
	"./discount/fr.json": [
		9349,
		9349
	],
	"./duration/en.json": [
		3393,
		3393
	],
	"./duration/fr.json": [
		5631,
		5631
	],
	"./en.json": [
		4200,
		4200
	],
	"./expense/en.json": [
		5597,
		457
	],
	"./expense/fr.json": [
		7444,
		7444
	],
	"./fr.json": [
		6222,
		6222
	],
	"./home/en.json": [
		4133,
		4133
	],
	"./home/fr.json": [
		2601,
		2601
	],
	"./invoice/en.json": [
		3203,
		3203
	],
	"./invoice/fr.json": [
		4550,
		4550
	],
	"./landing/en.json": [
		763,
		763
	],
	"./landing/fr.json": [
		4960,
		4960
	],
	"./languages/en.json": [
		229,
		229
	],
	"./languages/fr.json": [
		3734,
		3734
	],
	"./map/en.json": [
		4014,
		4014
	],
	"./map/fr.json": [
		134,
		134
	],
	"./market/en.json": [
		1384,
		1384
	],
	"./market/fr.json": [
		6106,
		6106
	],
	"./media/en.json": [
		6224,
		6224
	],
	"./media/fr.json": [
		3347,
		3347
	],
	"./not-found/en.json": [
		4810,
		4810
	],
	"./not-found/fr.json": [
		3362,
		3362
	],
	"./notifications/en.json": [
		5929,
		5929
	],
	"./notifications/fr.json": [
		6488,
		6488
	],
	"./order/en.json": [
		5605,
		5605
	],
	"./order/fr.json": [
		1734,
		1734
	],
	"./payment-mode/en.json": [
		571,
		571
	],
	"./payment-mode/fr.json": [
		6380,
		3278
	],
	"./permission/en.json": [
		7258,
		7258
	],
	"./permission/fr.json": [
		6099,
		6099
	],
	"./print/en.json": [
		4528,
		4528
	],
	"./print/fr.json": [
		5624,
		5624
	],
	"./product/en.json": [
		9585,
		9585
	],
	"./product/fr.json": [
		1835,
		1835
	],
	"./profile/en.json": [
		1317,
		1317
	],
	"./profile/fr.json": [
		596,
		596
	],
	"./provider/en.json": [
		4378,
		4378
	],
	"./provider/fr.json": [
		397,
		397
	],
	"./seller/en.json": [
		8056,
		8056
	],
	"./seller/fr.json": [
		7038,
		7038
	],
	"./stats/en.json": [
		287,
		287
	],
	"./stats/fr.json": [
		7550,
		7550
	],
	"./template/en.json": [
		5988,
		5988
	],
	"./template/fr.json": [
		9330,
		9330
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5068;
module.exports = webpackAsyncContext;